import { request } from 'assets/fetchHandler';

class OrderApi {
  /**
   * 获取订单列表
   * @param params
   * @returns {*}
   */
  getOrder(params) {
    return request({
      url: '/front/api/masterorder/list',
      params
    });
  }
  /**
   * 获取订单详情
   * @param params
   * @returns {*}
   */
  getOrderDetail(params) {
    return request({
      url: '/front/api/masterorder',
      params
    });
  }
  /**
   * 创建订单
   * @param params
   * @returns {*}
   */
  createOrder(data) {
    return request({
      url: '/front/api/masterorder',
      data,
      method: 'POST'
    });
  }
  /**
   * 取消订单
   * @param params
   * @returns {*}
   */
  deleteOrder(data) {
    return request({
      url: '/front/api/masterorder/delete',
      data,
      method: 'POST'
    });
  }
  /**
   * 获取支付凭证
   * @param params
   * @returns {*}
   */
  getWxPayInfo(data) {
    return request({
      url: '/front/api/masterorder/sign',
      data,
      method: 'POST'
    });
  }
  /**
   * 轮询订单状态
   * @param params
   * @returns {*}
   */
  getOrderStatus(params) {
    return request({
      url: '/front/api/masterorder/status',
      params
    });
  }

  /**
   * 调用新的订单接口
   */
  createNewOrder(data) {
    return request({
      url: '/front/api/order',
      data,
      method: 'POST'
    });
  }
  /**
   * 获取订单状态
   */
  checkOrderType(data) {
    return request({
      url: '/agate/pay/order/check',
      data,
      method: 'POST'
    });
  }

  getVirtualCoupon(params) {
    return request({
      url: '/course/portal/api/v1/coupon/getCoupon',
      params
    });
  }
}

export default new OrderApi();
